var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxCheckedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 3.79086 3.79086 2 6 2H22C24.2091 2 26 3.79086 26 6V22C26 24.2091 24.2091 26 22 26H6C3.79086 26 2 24.2091 2 22V6Z",
    fill: "#8052FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6427 8.23438C21.0661 8.59007 21.1211 9.22168 20.7654 9.64512L12.3672 19.6429C12.1808 19.8648 11.9074 19.9951 11.6176 20C11.3278 20.005 11.0501 19.8841 10.8563 19.6687L7.25705 15.6696C6.88711 15.2586 6.92043 14.6254 7.33148 14.2555C7.74252 13.8856 8.37564 13.9189 8.74559 14.3299L11.5745 17.4731L19.232 8.35705C19.5876 7.93361 20.2193 7.87869 20.6427 8.23438Z",
    fill: "#FCFCFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxCheckedIcon);
export default __webpack_public_path__ + "static/media/box-checked-icon.10c12ccbaffaa355666bfafea339de3c.svg";
export { ForwardRef as ReactComponent };